module.exports = __webpack_public_path__ + "img/65_old.73df550a.png";